export default __webpack_public_path__ + "static/media/DUET.0f0888ec.svg";